<template>
    <div class="floor brand">
		<!-- 楼层标题 -->
		<div class="floor_title">
		    <div class="floor_title_content">
		        <span class="floor_title_border"></span>
		        <span class="floor_title_content_index">{{ floorConfig.index || "资讯" }}</span>
		        <span class="floor_title_content_text">{{ floorConfig.title || "" }}</span>
		    </div>
		    <div class="other-title" >
		        <router-link to="/news">查看更多<i class="iconfont iconarrow-right"></i></router-link>
		    </div>
		</div>
        <!-- 楼层内容区 -->
        <div class="floor-content">
			<div class="hot">
				<div class="thumb" v-if="hotList.length>0" @click="$router.pushToTab({ path: '/news-detail-' + hotList[0].id})">
					<img fit="cover" class="imgae" :src="$img(hotList[0].image)" @error="hotList[0].image = defaultGoodsImage" />
				</div>
				<div class="info-list" >
					<div class="item" v-for="(item,index) in hotList" :key="index" @click="$router.pushToTab({ path: '/news-detail-' + item.id })">
						<!-- <router-link :to="`/news-detail-${item.id}`" target="_blank"> -->
						<p>{{item.title}}</p>
						<span>{{item.datetime.date}}</span>
						<!-- </router-link> -->
					</div>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in list" :key="index" @click="$router.pushToTab({ path: '/news-detail-' + item.id })">
					<el-image fit="cover" class="imgae" :src="$img(item.image)" @error="item.image = defaultGoodsImage" />
					<!-- <router-link :to="`/news-detail-${item.id}`" target="_blank"> -->
					<div class="info">
						<p>{{item.title}}</p>
						<span>{{item.create_time}}</span>
					</div>
					<!-- </router-link> -->
				</div>
			</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    // import { floorGoods, brandList } from "@/api/goods/goods"
	import { newsList } from "@/api/cms/news"
	
    export default {
        name: "news",
        components: {
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                hotList: [],
				list: []
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getHotList()
			this.getList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            tobrand(item) {
                if (item) {
                    this.$router.pushToTab(`/list?brand_id=${item.brand_id}`)
                }
            },
			getList() {
			    newsList({
					// flag:1,
					page_size:10
				}).then(res => {
			            this.list = res.data.list
			        })
			        .catch(err => {})
			},
            getHotList() {
                // const sku_ids = this.floorConfig.rightCargos
                //     .map(item => {
                //         return item.sku_id
                //     })
                //     .toString()
				// console.log(111)
                newsList({
					flag:1,
					page_size:4
				}).then(res => {
                        this.hotList = res.data.list
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
		width: 1210px;
		&_title {
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    padding-right: 20px;
		    &_border {
		        display: inline-block;
		        width: 5px;
		        height: 28px;
		        background-color: $base-color;
		        margin-right: 12px;
		        vertical-align: top;
		    }
		
		    &_content {
		        font-size: 20px;
		        padding-top: 10px;
		        padding-bottom: 10px;
		        height: 48px;
		        line-height: 28px;
		        // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
		        box-sizing: border-box;
		
		        &_index {
		            display: inline-block;
		            color: $ns-text-color-black;
		            padding-right: 8px;
		            font-weight: 600;
		        }
		
		        &_text {
		            font-weight: 600;
		            display: inline-block;
		            color: $base-color;
		        }
		    }
			.other-title {
			    a {
			        color: #838383;
			
			        i {
			            font-size: 14px;
			        }
			
			        &:hover {
			            color: $base-color;
			        }
			    }
			}
		}
		
        .floor-content {
            display: flex;
            flex-wrap: wrap;
			background-color: #ffffff;
			padding: 25px 20px;
			.hot{
				width: 415px;
				// height: 340px;
				// background-color: #03A9F4;
				display: block;
				.thumb{
					width: 377px;
					height: 210px;
					cursor: pointer;
					img{
						width: 377px;
						height: 210px;
					}
				}
				.info-list{
					// padding: 25px 0;
					margin-top: 25px;
					.item{
						cursor: pointer;
						display: flex;
						line-height: 35px;
						// a {
						// 	display: flex;
						// 	line-height: 35px;
						// }
						& p{
							flex: 1;
							overflow: hidden;
							text-overflow:ellipsis;
							white-space: nowrap;
						}
						& span{
							width: 100px;
						}
					}
				}
			}
			.list{
				flex:1;
				// width: 815px;
				display: flex;
				flex-flow: wrap;
				// padding: 0 25px;
				box-sizing: border-box;
				// display: block;
				.item:nth-child(2n+1){
					// margin-left: 0;
				}
				.item{
					width: 48%;
					margin: 0 auto;
					// width: 130px;
					// margin: 0 0 5px 5px;
					
					// float: left;
					// height: 80px;
					cursor: pointer;
					display: flex;
					height: 60px;
					overflow: hidden;
					// border-bottom: 1px solid #ccc;
					.imgae{
						width: 92px;
						height: 60px;
						// height: auto;
						// margin: 20px auto 10px auto;
						display: block;
					}
					.info{
						flex: 1;
						padding: 0  0 0 10px;
						overflow: hidden;
						height: 60px;
						p{
							// text-align: left;
							line-height: 30px;
							word-break:keep-all;/* 不换行 */
							white-space:nowrap;/* 不换行 */
							overflow:hidden;
							text-overflow:ellipsis;
						}
						span{
							// text-align: right;
						}
					}
					
				}
			}
			.ad{
				width: 195px;
				height: 340px;
				background-color: #8BC34A;
				img{
					width: 100%;
					height: 340px;
				}
			}
        }
    }
</style>
